/**
 * Whether a company's saved site set is no longer the one a change was prepared against.
 *
 * A save replaces the whole draft, so a change prepared before another save — a chat proposal card
 * made before the page saved, or a card saved once already and shown again — would undo that save
 * without a word. Every save recreates every site row, so any save in between changes the set of
 * ids; publishing flips the set's status in place and keeps them. Comparing ids therefore detects
 * exactly the saves that matter, and nothing else.
 *
 * Shared by the card, which uses it to turn its save off before the user tries, and by the save
 * endpoint, which refuses a stale save even when it arrives between the card's last read and the
 * write.
 */
export function savedSetChangedSince(preparedWithIds: readonly number[], currentIds: readonly number[]): boolean {
  if (preparedWithIds.length !== currentIds.length) return true;
  const current = new Set(currentIds);
  return preparedWithIds.some(id => !current.has(id));
}
